/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineAxis: {
  name: 'line-axis';
  data: string;
} = {
  name: 'line-axis',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1a.5.5 0 0 0-1 0v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 0-1H1.5V8.207l2.5-2.5 3.646 3.647a.5.5 0 0 0 .708 0l5-5a.5.5 0 0 0-.708-.708L8 8.293 4.354 4.646a.5.5 0 0 0-.708 0L1.5 6.793V1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
